import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map, throwError } from 'rxjs';

import { UserOrganigramaSearchPayload } from '../interfaces/common.interface'

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    private token!: string;
    private basePath = environment.interop.basePath;
    private httpOptions: any;
    private getDirectiiUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.directie.getDirectii
    private getDirectiiActiveUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.directie.getDirectiiActive
    private getCompartimenteUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.compartiment.getCompartimente
    private getCompartimenteActiveUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.compartiment.getCompartimenteActive
    private getCompartimenteByDirectieUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.compartiment.getCompartimenteByDirectie
    private getCompartimenteByDgaspcUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.compartiment.getCompartimenteByDgaspc
    private getJudeteActiveUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.judet.listActive

    private getUsersUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.user.getUsersList
    private getUsersByOrganigramaUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.user.getActiveUsersByOrganigrama

    private getFunctiiUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.functiiUser.list;
    private getCerereStatusesActiveUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.cerereStatus.listActive
    private getCererePrioritiesActiveUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.cererePriority.listActive
    private getCerereTypesUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.cerereType.list
    private getCerereTypesActiveUrl = this.basePath + environment.interop.dgaspc.nomenclatoare.cerereType.listActive

    private getTariActiveUrl = this.basePath + environment.interop.dgaspc.tari.getTariActive
    private getJudeteActiveSearchUrl = this.basePath + environment.interop.dgaspc.judete.getJudeteActive
    private getLocalitatiActiveUrl = this.basePath + environment.interop.dgaspc.localitati.getLocalitatiActive
    private getStraziActiveUrl = this.basePath + environment.interop.dgaspc.strazi.getStraziActive

    constructor(private http: HttpClient) { }

    getDirectii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get directii active:', error);
                    return throwError(error);
                })
            );
    }

    getDirectiiActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get directii active:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimente() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente active:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteByDirectieId(id: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteByDirectieUrl + id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getCompartimenteByDirectieId:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteByDgaspc() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteByDgaspcUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente by dgaspc:', error);
                    return throwError(error);
                })
            );
    }

    getJudeteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getJudeteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get judete active:', error);
                    return throwError(error);
                })
            );
    }

    getUsers() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getUsersUrl
            )
            .pipe(
                map((response: any) =>
                    response.data.map((item: any) => ({ id: item.id_user, name: item.name }))
                ),
                catchError((error) => {
                    console.error('Error in getUsers:', error);
                    return throwError(error);
                })
            );
    }

    getUsersByOrganigrama(data: UserOrganigramaSearchPayload) {
        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(this.getUsersByOrganigramaUrl, data, this.httpOptions)
            .pipe(
                map((response: any) =>
                    response.data.map((item: any) => ({ id: item.id, name: item.name }))
                ),
                catchError((error) => {
                    console.error('Error in getUserTypeActive:', error);
                    return throwError(error);
                })
            );
    }

    getCerereStatusesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCerereStatusesActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        archive: item.archive,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request statuses active:', error);
                    return throwError(error);
                })
            );
    }

    getCererePrioritiesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCererePrioritiesActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request priorities active:', error);
                    return throwError(error);
                })
            );
    }

    getCerereTypesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCerereTypesActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request types active:', error);
                    return throwError(error);
                })
            );
    }

    getCerereTypesByComp(id: number) {
        let payload = { compartiment: id };

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCerereTypesUrl, { params: payload }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request types by comp:', error);
                    return throwError(error);
                })
            );
    }

    getFunctii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getFunctiiUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get functii:', error);
                    return throwError(error);
                })
            );
    }


    getTariActive(name?: string) {
        let params = new HttpParams();
        if (name !== undefined) {
            params = params.set('name', name);
        }

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getTariActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get tari active:', error);
                    return throwError(error);
                })
            );
    }

    getJudeteActiveSearch(id_country?: number, name?: string) {
        let params = new HttpParams();
        if (id_country !== undefined && id_country !== -1) {
            params = params.set('id_country', id_country);
        }
        if (name !== undefined) {
            params = params.set('name', name);
        }

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getJudeteActiveSearchUrl, { params }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get judete active:', error);
                    return throwError(error);
                })
            );
    }

    getLocalitatiActive(id_country?: number, id_judet?: number, name?: string) {
        let params = new HttpParams();
        if (id_country !== undefined && id_country !== -1) {
            params = params.set('id_country', id_country);
        }
        if (id_judet !== undefined && id_judet !== -1) {
            params = params.set('id_judet', id_judet);
        }
        if (name !== undefined) {
            params = params.set('name', name);
        }

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getLocalitatiActiveUrl, { params }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get localitati active:', error);
                    return throwError(error);
                })
            );
    }

    getStraziActive(id_country?: number, id_judet?: number, id_localitate?: number, name?: string) {
        let params = new HttpParams();
        if (id_country !== undefined && id_country !== -1) {
            params = params.set('id_country', id_country);
        }
        if (id_judet !== undefined && id_judet !== -1) {
            params = params.set('id_judet', id_judet);
        }
        if (id_localitate !== undefined && id_localitate !== -1) {
            params = params.set('id_localitate', id_localitate);
        }
        if (name !== undefined) {
            params = params.set('name', name);
        }

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getStraziActiveUrl, { params }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get strazi active:', error);
                    return throwError(error);
                })
            );
    }
}
